import { AssessmentOverviewQuestionnaireItem } from '../sections/AssessmentOverview/questionnaire'
import { MedicalBackgroundQuestionnaireItem } from '../sections/MedicalBackground/questionnaire'
import { MedicationsQuestionnaireItem } from '../sections/Medications/questionnaire'
import { PatientOverviewQuestionnaireItem } from '../sections/PatientOverview/questionnaire'
import { DischargePlanningQuestionnaireItem } from '../sections/DischargePlanning/questionnaire'
import { SkilledNeedsQuestionnaireItem } from '../sections/SkilledNeeds/questionnaire'
import { SupervisoryReviewQuestionnaireItem } from '../sections/SupervisoryReview/questionnaire'
import { FinalStepsQuestionnaireItem } from '../sections/FinalSteps/questionnaire'

const SocAssessmentQuestionnaireItemCore = {
  // ADL needs
  ADL_NEEDS: 'adl-needs',
  ADL_NEEDS_NEED: 'adl-needs/need',
  ADL_NEEDS_NEED_ID: 'adl-needs/need/id',
  ADL_NEEDS_NEED_OBSERVATION_REFERENCE: 'adl-needs/need/observation-reference',
  ADL_NEEDS_NEED_NAME: 'adl-needs/need/name',
  ADL_NEEDS_NEED_NEW_NOTE: 'adl-needs/need/new-note',
  ADL_NEEDS_NEED_IS_ARCHIVED: 'adl-needs/need/is-archived',
  ADL_NEEDS_NEED_LAST_NOTE_AUTHOR: 'adl-needs/need/last-note-author',
  ADL_NEEDS_NEED_LAST_NOTE_DATE: 'adl-needs/need/last-note-date',
  ADL_NEEDS_NEED_LAST_NOTE_TEXT: 'adl-needs/need/last-note-text',

  // Authorizations
  AUTHORIZATION: 'authorization',
  AUTHORIZATION_AUTHORIZATION: 'authorization/authorization',
  AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE:
    'authorization/authorization/authorization-source',
  AUTHORIZATION_AUTHORIZATION_REQUESTED_HOURS: 'authorization/authorization/requested-hours',

  // Plan of care
  PLAN_OF_CARE: 'plan-of-care',
  PLAN_OF_CARE_GOALS: 'plan-of-care/goals',
  PLAN_OF_CARE_GOALS_GOAL: 'plan-of-care/goals/goal',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS: 'plan-of-care/patient-interventions',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO:
    'plan-of-care/patient-interventions/intervention-info',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INTERVENTION:
    'plan-of-care/patient-interventions/intervention-info/intervention',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_CATEGORY:
    'plan-of-care/patient-interventions/intervention-info/category',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_GOAL:
    'plan-of-care/patient-interventions/intervention-info/goal',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TASK:
    'plan-of-care/patient-interventions/intervention-info/task',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INDICATION:
    'plan-of-care/patient-interventions/intervention-info/indication',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TYPE:
    'plan-of-care/patient-interventions/intervention-info/type',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INSTRUCTION:
    'plan-of-care/patient-interventions/intervention-info/instruction',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_PATIENT_CENTERED_GOAL:
    'plan-of-care/patient-interventions/intervention-info/patient-centered-goal',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_ADDITIONAL_DETAILS:
    'plan-of-care/patient-interventions/intervention-info/additional-details',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_VISITS:
    'plan-of-care/patient-interventions/intervention-info/visits',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_FREQUENCY:
    'plan-of-care/patient-interventions/intervention-info/frequency',

  // Visit scheduling
  VISIT_SCHEDULING: 'visit-scheduling',
  VISIT_SCHEDULING_PATIENT_SCHEDULE: 'visit-scheduling/patient-schedule',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_WAKEUP_TIME: 'visit-scheduling/patient-schedule/wakeup-time',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_BEDTIME: 'visit-scheduling/patient-schedule/bedtime',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES: 'visit-scheduling/patient-schedule/school-times',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_DAY:
    'visit-scheduling/patient-schedule/school-times/day',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD:
    'visit-scheduling/patient-schedule/school-times/period',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_START:
    'visit-scheduling/patient-schedule/school-times/period/start',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_END:
    'visit-scheduling/patient-schedule/school-times/period/end',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS:
    'visit-scheduling/patient-schedule/other-appointments',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_NAME:
    'visit-scheduling/patient-schedule/other-appointments/name',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD:
    'visit-scheduling/patient-schedule/other-appointments/period',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_START:
    'visit-scheduling/patient-schedule/other-appointments/period/start',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_END:
    'visit-scheduling/patient-schedule/other-appointments/period/end',
  VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_REPEATS_ON_DAY:
    'visit-scheduling/patient-schedule/other-appointments/repeats-on-day',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE: 'visit-scheduling/caregiver-schedule',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_SPLIT_CAREGIVERS:
    'visit-scheduling/caregiver-schedule/split-caregivers',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_SPLIT_PRIMARY_CAREGIVER:
    'visit-scheduling/caregiver-schedule/caregiver-split/primary-caregiver',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS:
    'visit-scheduling/caregiver-schedule/caregiver-timings',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_CAREGIVER:
    'visit-scheduling/caregiver-schedule/caregiver-timings/caregiver',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS:
    'visit-scheduling/caregiver-schedule/caregiver-timings/timings',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_ENABLED:
    'visit-scheduling/caregiver-schedule/caregiver-timings/timings/enabled',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_DAY:
    'visit-scheduling/caregiver-schedule/caregiver-timings/timings/day',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_PERIOD:
    'visit-scheduling/caregiver-schedule/caregiver-timings/timings/period',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_PERIOD_START:
    'visit-scheduling/caregiver-schedule/caregiver-timings/timings/period/start',
  VISIT_SCHEDULING_CAREGIVER_SCHEDULE_CAREGIVER_TIMINGS_TIMINGS_PERIOD_END:
    'visit-scheduling/caregiver-schedule/caregiver-timings/timings/period/end',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VALID: 'visit-scheduling/custom-schedule/valid',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS: 'visit-scheduling/custom-schedule/visits',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD: 'visit-scheduling/custom-schedule/visits/period',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_START:
    'visit-scheduling/custom-schedule/visits/period/start',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_END:
    'visit-scheduling/custom-schedule/visits/period/end',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_CAREGIVER:
    'visit-scheduling/custom-schedule/visits/period/caregiver',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_WEEKDAY:
    'visit-scheduling/custom-schedule/visits/period/weekday',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_CHANGE_REASON: 'visit-scheduling/custom-schedule/change-reason',
  VISIT_SCHEDULING_CUSTOM_SCHEDULE_ADDITIONAL_NOTES:
    'visit-scheduling/custom-schedule/additional-notes',

  // Narrative
  NARRATIVE_BACKGROUND: 'narrative/background',
  NARRATIVE_SYSTEM_SUMMARIES: 'narrative/system-summaries',
  NARRATIVE_CLINICAL_OVERVIEW: 'narrative/clinical-overview',
  NARRATIVE_SKILLED_NEEDS: 'narrative/skilled-needs',
  NARRATIVE_ADL_NEEDS: 'narrative/adl-needs',
  NARRATIVE_CARE_COORDINATION: 'narrative/care-coordination',
  NARRATIVE_PATIENT_SERVICES: 'narrative/patient-services',
  NARRATIVE_PATIENT_GOALS: 'narrative/patient-goals',
  NARRATIVE_CLINICAL_EDUCATION: 'narrative/clinical-education',
  NARRATIVE_FINAL_NOTES: 'narrative/final-notes'
} as const

export const SocAssessmentQuestionnaireItem = {
  ...SocAssessmentQuestionnaireItemCore,
  ...AssessmentOverviewQuestionnaireItem,
  ...PatientOverviewQuestionnaireItem,
  ...DischargePlanningQuestionnaireItem,
  ...MedicalBackgroundQuestionnaireItem,
  ...MedicationsQuestionnaireItem,
  ...SkilledNeedsQuestionnaireItem,
  ...SupervisoryReviewQuestionnaireItem,
  ...FinalStepsQuestionnaireItem
} as const

export type SocAssessmentQuestionnaireItem =
  (typeof SocAssessmentQuestionnaireItem)[keyof typeof SocAssessmentQuestionnaireItem]
